var _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReceive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "475px",
    height: "446px",
    viewBox: "0 0 475 446",
    enableBackground: "new 0 0 475 446",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ThhD88.tif",
    display: "none"
  }, /*#__PURE__*/React.createElement("image", {
    display: "inline",
    overflow: "visible",
    width: 512,
    height: 428,
    id: "Layer_0_1_",
    xlinkHref: "9DC35140A5A1A299.png",
    transform: "matrix(1 0 0 1 -22 19)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291,10.8C291,4.835,286.165,0,280.2,0h-84.4C189.835,0,185,4.835,185,10.8v205.4c0,5.964,4.835,10.8,10.8,10.8h84.4 c5.965,0,10.8-4.835,10.8-10.8V10.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M362.338,168c16.366,0,20.56,9.899,9.319,21.795l-113.462,120.16c-11.239,11.896-29.633,11.938-40.873,0.042 L103.861,189.774C92.621,177.878,96.814,168,113.18,168H362.338z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M475,376c0-9.941-8.059-18-18-18H18c-9.941,0-18,8.059-18,18v52c0,9.941,8.059,18,18,18h439c9.941,0,18-8.059,18-18V376z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReceive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/receive.7d2647fff80ce75fed60b905bb687d34.svg";